<template>
	<div style="padding-top: 0 !important;">
		<im ref="myim"></im>
		<header style="position: fixed; top: 0; left: 0; right: 0;background: #F5F5F5;z-index: 100;">
			<div class="box">
				<ul class="left">
					<div
						style="height: 48px;width: 50px; line-height: 48px;display: inline-block;position: relative; float: left;margin-left: 50px;">
						<img style="height: 30px; position: absolute; top: 9px;left: 10px;"
							src="../assets/img/DefaultHead.png" alt="">
					</div>
					<div
						style="height: 48px;line-height: 48px;padding-left: 20px;font-size: 20px;display: inline-block;font-weight: 600;">
						客汇宝
					</div>
				</ul>
				<!-- <ul class="left">
					<router-link :to="{name:'index'}" tag="li" :class="{'crue':name=='index'}">
						首页
		  		</router-link>
		  		<router-link :to="{name:'Method'}" tag="li" :class="{'crue':name=='Method'}">
						使用方法
		  		</router-link>
		  		<li :class="{'crue':name=='robotall'}">
						机器人 <i class="el-icon-arrow-down" style="font-weight: bold;"></i>
						<div @click.stop="thisshow"  @mouseenter="enters()" @mouseleave="leaver()" :class="{'thisactive':show2}" style="position: absolute;left: 0;top:0;width: 100%;height: 100%;">
							
								<div style="position: fixed;width: 100%;top: 51px;left: 0;">
								      <transition name="el-zoom-in-top">
								        <div v-show="show2" class="transition-box">
								        		<div v-if="classInfo.length=='0'" style="padding: 20px;font-size: 18px;font-weight: normal;">
								        			暂无机器人信息
								        		</div>
														<div v-else>
											        	<div class="titleBox" v-for="item in classInfo">
											        		<h1>{{item.text}}</h1>
											        		<div class="item" v-for="list in item.children" @click.top="go(list)">{{list.text}}</div>
											        	</div>															
														</div>
								        </div>
								      </transition>
								</div>							
							
							
						</div>
		  		</li>
		  		<li @click="gotopc()" v-if='xianshi' class="hidenIm">
						客汇宝网页版
		  		</li>
				  <li  @click="imshow();dengluss()" v-if='!xianshi' class="hidenIm">
					客汇宝网页版
			  </li>
					<li>
						<a href="https://support.qq.com/products/276791" target="_blank">常见问题</a>
					</li>
					<router-link :to="{name:'quangu'}" tag="li" :class="{'crue':name=='quangu'}">
						券谷
				  </router-link>
				</ul> -->
				<ul class="right show">

					<li @click="imshow();denglus()" v-if="!login">登录</li>
					<router-link :to="{name:'exp'}" v-if="login" tag="li">
						管理控制台
					</router-link>

				</ul>
			</div>



		</header>
		<div
			style="height: 900px;width: 200px;background-color: #545C64;position: fixed; top: 50px;left: 0;color: #fff;z-index: 500;">
			<div class="yang5">
				<router-link :to="{name:'index'}" tag="li" :class="{'crue':name=='index'}">
					首页
				</router-link>
			</div>
			<div class="yang4">
				<router-link :to="{name:'Method'}" tag="li" :class="{'crue':name=='Method'}">
					使用方法
				</router-link>
			</div>
			<div class="yang6">
				<router-link :to="{name:'jiqiren'}" tag="li" :class="{'crue':name=='jiqiren'}">
					机器人
				</router-link>
				<!-- <li :class="{'crue':name=='robotall'}">
					机器人 
					<div @click.stop="thisshow"  @mouseenter="enters()" @mouseleave="leaver()" :class="{'thisactive':show2}" style="position: absolute;left: 0;top:0;width: 100%;height: 100%;">
						
							<div style="position: fixed;width: 100%;top: 51px;left: 0;">
								  <transition name="el-zoom-in-top">
									<div v-show="show2" class="transition-box">
											<div v-if="classInfo.length=='0'" style="padding: 20px;font-size: 18px;font-weight: normal;">
												暂无机器人信息
											</div>
													<div v-else>
													<div class="titleBox" v-for="item in classInfo">
														<h1>{{item.text}}</h1>
														<div class="item" v-for="list in item.children" @click.top="go(list)">{{list.text}}</div>
													</div>															
													</div>
									</div>
								  </transition>
							</div>							
						
						
					</div>
			  </li> -->

			</div>
			<!-- <div class="yang6">
				<router-link :to="{name:'gongju'}" tag="li" :class="{'crue':name=='gongju'}">
					实用工具
			  </router-link>
			</div> -->
			<div class="yang6">
				<router-link :to="{name:'wendang'}" tag="li" :class="{'crue':name=='wendang'}">
					文档转换
				</router-link>
			</div>
			<div class="yang6">
				<router-link :to="{name:'shiming'}" tag="li" :class="{'crue':name=='shiming'}">
					实名认证
				</router-link>
			</div>
			<!-- <div class="yang6">
				<router-link :to="{name:'chatgpt'}" tag="li" :class="{'crue':name=='chatgpt'}">
					AI助手
			  </router-link>
			</div> -->
			<div class="yang3" @click="gotopc()" v-if='xianshi'>
				客汇宝网页版
			</div>
			<!-- imshow(); -->
			<div @click="dengluss()" v-if='!xianshi'
				style="height: 50px;width: 100%; line-height: 50px;text-align: center;background: #fff;color: #409EFF !important ;">

				客汇宝网页版

			</div>
			<div class="yang7">
				<router-link :to="{name:'huibaoAccount'}" tag="li" :class="{'crue':name=='huibaoAccount'}">
					汇宝号
				</router-link>
			</div>
			<div style="position: relative;">
				<div class="yang9">
					<router-link :to="{name:'informationApi'}" tag="li" :class="{'crue':name=='informationApi'}">
						API
					</router-link>
				</div>

				<div class="boxs">
					<div style="width:200px ;margin-left: 20px;height: 500px; float: left;overflow-y: scroll;"
						v-for="(items,index) in tab">
						<div>
							<img style="width:40px ;height: 40px;" src="../assets/img/api2.png" alt="">
						</div>
						<div style="margin-bottom: 30px;font-size: 24px;font-weight: 550;">
							{{items.classifyName}}
						</div>
						<div v-for="item in items.dataPayInterfaceList" @click="chakan(item.id)"
							style="line-height: 40px;display: flex;justify-content: flex-start;">
							<div class="bianhua">{{item.interfaceName}}</div>
							<!-- <div v-if="item.type==2" style="position: relative;margin-left: 5px;">
								<img style="width:16px ;height: 16px;position: absolute;top: 0;"
									src="../assets/img/huo.png" alt="">
							</div> -->
						</div>
					</div>





				</div>
			</div>

			<!-- <div class="yang6">
				<router-link :to="{name:'acupoint'}" tag="li" :class="{'crue':name=='acupoint'}">
					经络助手
			  </router-link>
			</div> -->
			<!-- <div class="yang2" >
				<li>
					<a href="https://support.qq.com/products/276791" target="_blank" style="color: #fff;">常见问题</a>
				</li>
			</div> -->
			<!-- <div class="yang1" >
				<router-link :to="{name:'quangu'}" tag="li" :class="{'crue':name=='quangu'}">
					券谷
			  </router-link>
			</div> -->
		</div>

	</div>
</template>

<script>
	import qs from "qs"
	import im from "@/components/im/khbIM"
	export default {
		components: {
			im
		},
		data() {
			return {
				show2: false,
				classInfo: [],
				name: '',
				xianshi: true,
				isSort: -1,
				tab: [
					// {
					// 	type: '1',
					// 	img: '',
					// 	classification: [{ name: '认证宝(实名认证)', id: 1, }, { name: '全网手机三要素验证', id: 2, }, { name: '银行卡三要素验证', id: 3, }, { name: '银行卡四要素验证', id: 4, }, { name: '人像对比', id: 5, }, { name: '全网手机状态验证', id: 6, }, { name: '全网手机在网时长验证', id: 7, }, { name: '全网手机消费区间验证', id: 8, }]
					// },
					// {
					// 	type: '2',
					// 	img: '',
					// 	classification: [{ name: '企业四要素验证', id: 9, }, { name: '企业信息综合评估', id: 10, }, { name: '企业对公账户核验', id: 11, }, { name: '企业详情信息核验', id: 12, }, { name: '企业信息数量查验', id: 13, }, { name: '企业经营凭证核验', id: 14, }, { name: '企业红黑名单核验', id: 15, }, { name: '企业行政处罚信息查验', id: 16, }],
					// },
					// {
					// 	type: '3',
					// 	img: '',
					// 	classification: [{ name: '全国车辆配置查验', id: 17, }, { name: '车辆运力评估', id: 18, }, { name: '全国商用车合格证核验', id: 19, }, { name: '货车车险风控评分模型', id: 20, }, { name: '全国乘用车合格证核验', id: 21, }, { name: '货车月经营分部评估', id: 22, }, { name: '全国车辆上险查验(车牌号)', id: 23, }, { name: '车辆品牌型号查验', id: 24, }],
					// },
					// {
					// 	type: '4',
					// 	img: '',
					// 	classification: [{ name: '认证宝(实名认证)', id: 1, }, { name: '企业四要素验证', id: 9, }, { name: '企业信息综合评估', id: 10, }, { name: '全网手机三要素验证', id: 2, }, { name: '企业对公账户核验', id: 11, }, { name: '车辆运力评估', id: 18, }, { name: '企业详情信息核验', id: 12, }, { name: '货车车险风控评分模型', id: 20, }],
					// },
					// {
					// 	type: '5',
					// 	img: '',
					// 	classification: [{ name: '银行卡OCR识别', id: 25, }, { name: '行驶证OCR识别', id: 26, }, { name: '身份证OCR识别', id: 27, }, { name: '驾驶证OCR识别', id: 28, }, { name: '营业执照OCR识别', id: 29, }, { name: '港澳台居民居住证OCR识别', id: 30, }, { name: '港澳台居民来往内地通行证OCR识别', id: 31, }, { name: '护照（港澳台地区及境外护照）识别', id: 32, },]

					// }
				],

			}
		},
		computed: {
			login() {
				return this.$store.state.loginTrue
			}
		},
		methods: {
			chakan(id) {
				this.$router.replace({
					name: 'informationApidetails',
					query: {
						info: id
					}
				})
			},
			gaibian(data) {
				if (data != undefined) {
					this.$refs.myim.mygo1(data)
					this.xianshi = false
				}


			},
			denglus() {

				this.$store.commit('logindengluFc', true);
			},
			gotopc() {

				this.$router.push({ name: 'Chatwindow' })

			},
			dengluss() {
				this.$store.commit('logindengluFc', true);
			},
			imshow() {
				this.$refs.myim.mygo()
			},

			getClass() {
				this.$axios.post('/goods/dataPayInterface/getdatapayclassify')
					.then(userData => {
						if (userData.data.resultCode == '0000') {
							this.tab = userData.data.resultInfo
						} else {
							this.$message.error(userData.data.resultMsg);
						}

					}).catch(error => {
						console.log(error)
					})
			},
			// enters(){
			// 	if(document.body.clientWidth>640){
			// 		this.show2=true
			// 	}

			// },
			// leaver(){
			// 	this.show2=false
			// },
			// thisshow(){
			// 	if(document.body.clientWidth<640){
			// 		this.show2=!this.show2
			// 	}
			// },
			// getClass(){
			// 			this.$axios.post('/goods/pchome/v1/getProductList') 
			// 			.then(userData=>{
			// 				if(userData.data.resultCode=='0000'){
			// 					this.classInfo=userData.data.resultInfo
			// 				}else{
			// 					this.$message.error(userData.data.resultMsg);
			// 				}

			// 			}).catch(error=>{
			// 				console.log(error)
			// 			}) 		
			// }, 
			// go(data){
			// 	this.show2=false
			// 	this.$router.push({name:'robotall',query:{id:data.url}})
			// }
		},
		created: function () {
			this.name = this.$route.name
			this.getClass()
		},
		filters: {
			fenlei: function (data) {
				if (data == '1') {
					return '身份核验类'
				}
				if (data == '2') {
					return '企业信息核验类'
				}
				if (data == '3') {
					return '交通物流运输类'
				}
				if (data == '4') {
					return '风险评估'
				}
				if (data == '5') {
					return 'OCR识别'
				}

			},

		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.indexBox {
		position: fixed;
		width: 100%;
		left: 0;
		top: 0;
		background: #FFFFFF;
		overflow: hidden;
		z-index: 1;
	}

	.indexBox header {}

	.indexBox header .box {
		margin: auto;
		position: relative;
		overflow: hidden;
		border-bottom: 1px solid #e8e8e8;
	}

	.indexBox header ul {}

	.indexBox header ul li {
		color: #000000;
		font-weight: bold;
		cursor: pointer;
		display: inline-block;
		padding: 14px 15px;
		position: relative;
	}

	.indexBox header ul li a {
		color: #333333 !important;
	}

	.indexBox header ul.left {
		float: left;
	}

	.indexBox header ul.right {
		float: right;
	}

	/*.router-link-active{
	color: #000000 !important;
}
.router-link-exact-active{
	color: #409EFF !important;
}*/
	.crue {
		color: #409EFF !important;
		background: #fff;
	}

	.transition-box {
		overflow: auto;
		background: #FFFFFF !important;
		box-shadow: 0px 5px 5px #eae9e9;
		max-height: 400px;
		padding-bottom: 20px;
	}

	.transition-box .titleBox {
		float: left;
		padding: 0 20px;
	}

	.transition-box .titleBox h1 {
		font-weight: normal;
		font-size: 18px;
		padding: 0px;
		color: #191c3d;
		border-bottom: 1px solid #e8e8e8;
		line-height: 40px;
		margin-bottom: 10px;

	}

	.transition-box .titleBox .item {
		color: #9092A2 !important;
		font-weight: normal;
		padding: 5px 0;
	}

	.thisactive {
		border-bottom: 2px #409EFF solid;
	}

	.ql-container {
		position: static !important;
	}

	.yang1 {
		height: 50px;
		width: 100%;
		line-height: 50px;
		text-align: center;
		cursor: pointer;
	}

	.yang2 {
		height: 50px;
		width: 100%;
		line-height: 50px;
		text-align: center;
		cursor: pointer;
	}

	.yang3 {
		height: 50px;
		width: 100%;
		line-height: 50px;
		text-align: center;
		cursor: pointer;
	}

	.yang4 {
		height: 50px;
		width: 100%;
		line-height: 50px;
		text-align: center;
		cursor: pointer;
	}

	.yang5 {
		height: 50px;
		width: 100%;
		line-height: 50px;
		text-align: center;
		cursor: pointer;
	}

	.yang6 {
		height: 50px;
		width: 100%;
		line-height: 50px;
		text-align: center;
		cursor: pointer;
	}

	.yang7 {
		height: 50px;
		width: 100%;
		line-height: 50px;
		text-align: center;
		cursor: pointer;
	}

	.yang9 {
		height: 50px;
		width: 100%;
		line-height: 50px;
		text-align: center;
		cursor: pointer;
		position: relative;
	}

	.boxs {

		display: none !important;
		position: absolute;
		background: #EFF7FA;

		left: 200px;
		top: -200px;
		display: flex;
		justify-content: flex-start;
		padding: 20px;
		color: #000000;
	}

	.boxs:hover {
		display: block !important;
		position: absolute;
		background: #EFF7FA;
		width: 1200px;
		left: 200px;
		top: -200px;
		display: flex;
		justify-content: flex-start;
		padding: 20px;
		color: #000000;
	}

	.bianhua {

		font-size: 14px;
		color: #646566;
		cursor: pointer;
	}

	.yang1:hover {
		background: #C0C0C0;
	}

	.yang2:hover {
		background: #C0C0C0;
	}

	.yang3:hover {
		background: #C0C0C0;
	}

	.yang4:hover {
		background: #C0C0C0;
	}

	.yang5:hover {
		background: #C0C0C0;
	}

	.yang6:hover {
		background: #C0C0C0;
	}

	.yang7:hover {
		background: #C0C0C0;
	}

	.yang8:hover {
		background: #C0C0C0;
	}

	.yang9:hover {
		background: #C0C0C0;
	}

	.yang9:hover+.boxs {
		display: block !important;
		position: absolute;
		background: #EFF7FA;
		width: 1200px;
		left: 200px;
		top: -200px;
		display: flex;
		justify-content: flex-start;
		padding: 20px;
		color: #000000;

	}

	.bianhua:hover {
		color: #409EFF;
	}
</style>


// WEBPACK FOOTER //
// src/components/header.vue